import React from "react";
import { Divider } from "@mui/material";
import { useAppSelector } from "../../../State/Store";

const PricingCard = () => {
    // Connect to your central store state
    const { cart } = useAppSelector((state) => state.cart);

    // Dynamic calculations with exact matching specifications as defaults
    const subtotal = cart ? cart.totalMrpPrice : 0;
    const currentSellingPrice = cart ? cart.totalSellingPrice : 0;
    
    // Explicit requested calculation matching specifications
    const discount = subtotal - currentSellingPrice;
    
    // Check if the current route is the checkout page to hardcode shipping at 180
    const isCheckoutPage = window.location.pathname.includes('/checkout');
    const shipping = isCheckoutPage ? 0 : 0; 
    
    const platformFee = 0; // Free

    // Exact specification outcome mapping calculation tracking
    const totalAmount = currentSellingPrice + shipping + platformFee;

    return (
        <>
            <div className='space-y-3 p-5 text-sm text-gray-700'>
                <div className='flex justify-between items-center'>
                    <span>Subtotal</span>
                    <span className="font-medium text-gray-900">Ksh {subtotal.toLocaleString()}</span>
                </div>

                <div className='flex justify-between items-center'>
                    <span>Discount</span>
                    <span className="text-teal-600 font-medium">- Ksh {(discount > 0 ? discount : 0).toLocaleString()}</span>
                </div>

                <div className='flex justify-between items-center'>
                    <span>Shipping</span>
                    <span className={`font-medium ${isCheckoutPage ? "text-orange-600 font-bold" : "text-gray-900"}`}>
                        Ksh {shipping.toLocaleString()}
                    </span>
                </div>

                <div className='flex justify-between items-center'>
                    <span>Platform fee</span>
                    <span className="text-teal-600 font-semibold uppercase text-xs">Free</span>
                </div>
            </div>
            
            <Divider />

            <div className='flex justify-between items-center p-5 text-base font-bold text-gray-900'>
                <span>Total</span>
                <span>Ksh {(totalAmount).toLocaleString()}</span>
            </div>
        </>
    );
};

export default PricingCard;